export default "/fonts/vendor/katex/dist/KaTeX_Main-Italic.woff2?fe2176f79edaa716e6212cca53949439";